import { Injectable } from '@angular/core';
import { Observable, from, defer } from 'rxjs';
import { createAuth0Client, Auth0Client, Auth0ClientOptions } from '@auth0/auth0-spa-js';
import { environment } from 'src/environments/environment';
import { FEATURE_FLAGS } from 'src/app/shared/launchdarkly.constants';
import { LaunchDarklyService } from './launchdarkly.service';
import { switchMap, take } from 'rxjs/operators';
import { LDFlagValue } from 'launchdarkly-js-client-sdk';

@Injectable({
  providedIn: 'root',
})
export class OGAuth0Service {
  private clientPromise: Promise<Auth0Client> | null = null;
  private enableOgAuth0RefreshTokenFallbackFlagValue: boolean = false;
  constructor(private readonly ldService: LaunchDarklyService) {}

  private getConfig(): Auth0ClientOptions {
    return {
    domain: environment.OGAuth0Domain,
    clientId: environment.OGAuth0ClientId,
    authorizationParams: {
      redirect_uri: window.location.origin + '/callback-handler',
      audience: environment.OGAuth0Audience,
      scope: 'openid profile email'
    },
    useRefreshTokens: true,
    useRefreshTokensFallback: this.enableOgAuth0RefreshTokenFallbackFlagValue,
    cacheLocation: 'localstorage',
    useCookiesForTransactions: true
  }};

  getClient(): Promise<Auth0Client> {
    this.clientPromise ??= this.ldService
      .getFlagValue(FEATURE_FLAGS.ENABLE_OG_AUTH0_REFRESH_TOKEN_FALLBACK, false)
      .pipe(take(1))
      .toPromise()
      .then((value: LDFlagValue) => {
        this.enableOgAuth0RefreshTokenFallbackFlagValue = !!value;
        return this.createClient(this.getConfig());
      });
    return this.clientPromise!;
  }

  protected createClient(config: Auth0ClientOptions): Promise<Auth0Client> {
    return createAuth0Client(config);
  }

  getAccessTokenSilently(options?: any): Observable<any> {
    return defer(() => from(this.getClient())).pipe(
      switchMap(client => from(client.getTokenSilently(options)))
    );
  }
}